import React from 'react';
import { Helmet } from 'react-helmet-async';
import Stats from '../../../components/Global/BannerCard/Stats/Stats';
import LIRC from '../../../components/Global/BannerCard/LIRC/LIRC';
import ExpertiseSection from '../../../components/Global/BannerCard/Expertise/ExpertiseSection';
import THC from '../../../components/Global/BannerCard/T&HC/THC';
import MakeTheShift from '../../../components/MakeTheShift/MakeTheShift';
import CyientGrid from '../../../components/Global/BannerCard/CyientGrid/CyientGrid';
import CyientShowcase from '../../../components/Global/BannerCard/CyientShowcase/CyientShowcase';
import ContactPage from '../../../components/Global/BannerCard/DynamicHeader/ContactPage1';

const UtilitiesSpatialIntelligence = () => {
  return (
    <div>
      <Helmet>
        <title>Utilities & Spatial Intelligence | Intelligent Engineering Solutions</title>
        <meta
          name="description"
          content="Discover cutting-edge utilities and spatial intelligence solutions delivering intelligent engineering and spatial analytics for a smarter future."
        />
        <meta name="keywords" content="Utilities, Spatial Intelligence, Engineering Solutions, Spatial Analytics, Intelligent Engineering" />
        <meta name="robots" content="index, follow" />

        <meta property="og:title" content="Utilities & Spatial Intelligence | Intelligent Engineering Solutions" />
        <meta
          property="og:description"
          content="Discover cutting-edge utilities and spatial intelligence solutions delivering intelligent engineering and spatial analytics for a smarter future."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.yoursite.com/utilities-spatial-intelligence" />
        <meta property="og:image" content="https://www.yoursite.com/images/utilities-spatial-intelligence.jpg" />

       
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Utilities & Spatial Intelligence | Intelligent Engineering Solutions" />
        <meta
          name="twitter:description"
          content="Discover cutting-edge utilities and spatial intelligence solutions delivering intelligent engineering and spatial analytics for a smarter future."
        />
        <meta name="twitter:image" content="https://www.yoursite.com/images/utilities-spatial-intelligence.jpg" />
      </Helmet>

      <ContactPage
        title="ADVANCING UTILITIES & SPATIAL INTELLIGENCE SOLUTIONS"
        subTitle="Delivering cutting-edge intelligent engineering and spatial analytics."
        backgroundImage="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBxISEhISEhIVEhIVFhUVFRUVFRUVFRUVFRUXFhUVFRUYHSggGBolHRUVITEhJSkrLi4uFx8zODMtNygtLisBCgoKDg0OFxAQFy0dHR0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLf/AABEIAKgBLAMBIgACEQEDEQH/xAAYAAEBAQEBAAAAAAAAAAAAAAAABAUGAwf/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAFJAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//EABYRAQEBAAAAAAAAAAAAAAAAAAABAv/aAAgBAQABPxAA/8QAFhEBAQEAAAAAAAAAAAAAAAAAABEB/9oACAEDAQE/ED//xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAgEBPxB//8QAGxABAQEBAQAAAAAAAAAAAAAAAQARITFhcfD/2gAIAQEABj8CtYxb//EABwQAQACAwEBAAAAAAAAAAAAAAEAESExQVFhcf/aAAgBAQABPyGKymwDMSxHwMjJiXyNLv/9k="
        highlightWord="UTILITIES & SPATIAL INTELLIGENCE"
      />
      <Stats />
      <LIRC />
      <CyientShowcase />
      <CyientGrid />
      <ExpertiseSection />
      <THC />
      <MakeTheShift />
    </div>
  );
};

export default UtilitiesSpatialIntelligence;
